import { Fragment, useState, useEffect, useCallback } from 'react';
import SumsubWebSdk from '@sumsub/websdk-react'

import { Text } from '../../FormControls/Text';
import { Stack } from '../../FormControls/Stack';
import { Box } from '../../FormControls/Box';

import { ScreenControl } from '../ScreenControl';
import { useDispatch, useSelector } from 'react-redux';

import { getKYCToken, getKYCStatus, updateUser } from '../../../../main/slices/userSlice';
import { LoadingComponent } from '../../LoadingComponent';
import { Person } from '@mui/icons-material';

const Main = ({ dimensions }) => {

    const REFRESH_RATE = 10; //IN SECONDS

    const dispatch = useDispatch();
    const [token, setToken] = useState({ code: "NO_TOKEN", value: null });

    const handleStatusChange = (status) => {
        // IF KYC STATUS CHANGE, CHANGE VIEW AND START INTERVAL TO RETRIEVE KYC STATUS
        if (["idCheck.onApplicantSubmitted", "idCheck.applicantReviewComplete"].includes(status)) {
            setToken({ code: "KYC_PENDING" });
            if (!window.kycTimer) window.kycTimer = setInterval(() => getKYC(), 1000 * REFRESH_RATE);
        }
    }

    // RETRIEVE KYC STATUS
    const getKYC = useCallback(() => {
        dispatch(getKYCStatus())
            .unwrap()
            .then(({ response }) => {
                if (response.statusCode === 200) {
                    // IF approved CLEAR INTERVAL AND CHANGE VIEW
                    if (response.kyc === "approved") {
                        clearInterval(window.kycTimer);
                        setToken({ code: "KYC_APPROVED" });
                    }
                    else setToken({ code: "KYC_PENDING" });
                }
            })
            .catch(e => console.log(e));
    }, [dispatch])

    // RETRIEVE A NEW TOKEN FOR SUMSUB IFRAME
    const getToken = useCallback(() => {
        dispatch(getKYCToken())
            .unwrap()
            .then(({ response }) => {
                setToken({ code: response.code, value: response.token || null });
                // IF NOT APPROVED, RETRIEVE STATUS UNTIL IS APPROVED
                if (response.code !== "KYC_APPROVED" && (response.kyc !== "init" && response.kyc !== "none")) {
                    // RETRIEVE KYC STATUS AFTER THE REFRESH RATE IS COMPLETE
                    if (!window.kycTimer) setTimeout(
                        () => window.kycTimer = setInterval(() => getKYC(), 1000 * REFRESH_RATE),
                        1000 * REFRESH_RATE
                    );
                }
            })
            .catch(e => console.log(e));
    }, [dispatch, getKYC]);

    // UPDATE USER INFO WHEN KYC IS APPROVED
    const updateUserInfo = async () => await dispatch(updateUser())
        .unwrap()
        .then(({ response }) => {
            if (response.statusCode === 200) return true;
            else return false;
        })
        .catch(() => false);

    useEffect(() => {
        getToken();
        return () => clearInterval(window.kycTimer);
    }, [getToken])

    return (
        <Fragment>
            <Stack
                sx={{ ...dimensions }}
                flex={{
                    alignItems: "center",
                    alignContent: "center",
                    flexDirection: "column",
                    justifyContent: "center",
                }}
            >
                {/* DISPLAY SUMSUB IFRAME FOR NEW USERS WITH ON KYC */}
                {token.code === "NEW_TOKEN" &&
                    <Box classes={["card", "cardShadow", "marginTB1em"]} style={{ backgroundColor: "unset" }}>
                        <SumsubWebSdk
                            accessToken={atob(token.value)}
                            expirationHandler={(m) => { console.log(m) }}
                            config={{ lang: window.navigator.language.replaceAll(new RegExp(/-(.)+/g), "") }}
                            options={{}}
                            onMessage={(m) => handleStatusChange(m)}
                            onError={(e) => { console.log(e) }}
                        />
                    </Box>
                }

                {/* DISPLAY LAODING COMPONENT WHILE THE TOKEN IS BEING RETRIEVED */}
                {token.code === "NO_TOKEN" && <Box classes={["marginTB1em"]}>
                    <Text classes={["title", "center"]}> Estamos preparando todo </Text>
                    <LoadingComponent
                        style={{ margin: "0.3em auto", fontSize: "8em" }}
                    />
                </Box>}

                {/* DISPLAY LAODING COMPONENT WHILE THE KYC IS BEING CHECKED */}
                {token.code === "KYC_PENDING" && <Box classes={["marginTB1em"]}>
                    <Text classes={["titleNoMargin", "center"]}> Esto tomará unos segundos </Text>
                    <Text classes={["subtitle", "center"]}> Estamos comprobando tu identidad </Text>
                    <LoadingComponent
                        style={{ margin: "0.3em auto", fontSize: "8em" }}
                    />
                </Box>}

                {/* IN CASE THE KYC IS ALREADY APPROVED */}
                {token.code === "KYC_APPROVED" && <Box classes={["marginTB1em"]}>
                    <Text classes={["title", "center"]}> ¡Todo en orden! </Text>
                    <Text classes={["subtitle", "center"]}> Tu identidad ya fue verificada. Puedes continuar con tu registro. </Text>
                </Box>}
            </Stack>

            <ScreenControl
                disabled={token.code !== "KYC_APPROVED"}
                beforeSubmit={() => updateUserInfo()}
            />
        </Fragment >
    );
}


export const Kyc = ({ dimensions }) => {
    //const state = useSelector(({ user }) => user.kyc);
    const state = "needs-review";

    if (state === "needs-review" || state === "approved") return <>
        <Box classes={["marginTB1em"]}>

            <Stack style={{ margin: "1em 0 2em 0" }} flex={{
                alignItems: "center",
                justifyContent: "center",
            }}>
                <Box
                    superStyle={{ width: "auto" }}
                    classes={["glowingCircularBadge"]}
                    extraClasses="main-div main-div2"
                >
                    <Person style={{ fontSize: "10em", color: "#E2E5F0" }}></Person>
                </Box>
            </Stack>
            <Text classes={["titleMediumMargin", "center"]}> KYC Completado </Text>
            <Text classes={["subtitle", "center"]}> Tu identidad ya fue verificada. </Text>
            <Text classes={["subtitle", "center"]}> Puedes continuar con tu registro. </Text>
        </Box>
        <ScreenControl disabled={false} />
    </>
    else return <Main dimensions={dimensions} />
}